var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.281,
    height: 56.923,
    viewBox: "0 0 54.281 56.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172482",
    "data-name": "\\uADF8\\uB8F9 172482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121635",
    "data-name": "\\uD328\\uC2A4 121635",
    d: "M3213.923,1171.548s18.815,16.29,26.642,19.832c-12.314,29.112-31.148,33.4-31.148,33.4s-10.892-10.121-23.133-24.331C3209.767,1192.161,3213.923,1171.548,3213.923,1171.548Z",
    transform: "translate(-3186.283 -1167.856)",
    fill: "#6b6b6b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121636",
    "data-name": "\\uD328\\uC2A4 121636",
    d: "M3213.923,1149.571s18.815,16.29,26.642,19.832c-12.314,29.112-31.148,33.4-31.148,33.4s-10.892-10.121-23.133-24.331C3209.767,1170.184,3213.923,1149.571,3213.923,1149.571Z",
    transform: "translate(-3186.283 -1149.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121637",
    "data-name": "\\uD328\\uC2A4 121637",
    d: "M3223.832,1202.593a46.417,46.417,0,0,1,4.724,3.413c1.56,1.187,3.123,2.371,4.674,3.569q4.7,3.634,9.38,7.3c.453.355-.165.986-.612.643q-4.671-3.57-9.315-7.173c-1.547-1.2-3.083-2.414-4.621-3.625a46.841,46.841,0,0,1-4.514-3.737A.244.244,0,0,1,3223.832,1202.593Z",
    transform: "translate(-3194.735 -1193.658)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121638",
    "data-name": "\\uD328\\uC2A4 121638",
    d: "M3244.674,1226.562a12.834,12.834,0,0,1,2.2,1.629c.76.613,1.5,1.245,2.255,1.869,1.466,1.22,2.937,2.435,4.4,3.662,2.954,2.48,5.923,4.947,8.844,7.467.43.371-.172.988-.6.634-2.98-2.449-5.918-4.955-8.865-7.444-1.457-1.23-2.9-2.472-4.354-3.708-.742-.633-1.491-1.258-2.224-1.9a12.672,12.672,0,0,1-1.959-1.881C3244.216,1226.689,3244.481,1226.466,3244.674,1226.562Z",
    transform: "translate(-3217.984 -1213.61)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121639",
    "data-name": "\\uD328\\uC2A4 121639",
    d: "M3261.356,1251.9a11.766,11.766,0,0,1,2.326,1.7c.719.6,1.428,1.208,2.139,1.815q2.233,1.909,4.459,3.828,4.449,3.839,8.891,7.683c.449.39-.187,1.049-.634.666q-4.464-3.822-8.911-7.662-2.226-1.917-4.443-3.845c-.739-.642-1.479-1.283-2.209-1.936a11.072,11.072,0,0,1-1.9-1.951C3260.95,1252.009,3261.178,1251.813,3261.356,1251.9Z",
    transform: "translate(-3237.601 -1234.692)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121640",
    "data-name": "\\uD328\\uC2A4 121640",
    d: "M3288.119,1269.869a29.857,29.857,0,0,1,4.5,4.238q2.148,2.2,4.275,4.412l4.36,4.517q1.066,1.105,2.133,2.21.556.578,1.108,1.158a3.178,3.178,0,0,1,.444.479c.095.16.06.355.145.523a.2.2,0,0,1-.26.273c-.184-.1-.371-.084-.546-.187a2.448,2.448,0,0,1-.42-.417q-.559-.574-1.117-1.149-1.113-1.153-2.224-2.309l-4.263-4.425q-2.177-2.261-4.347-4.531a29.292,29.292,0,0,1-4-4.568C3287.825,1269.964,3287.981,1269.778,3288.119,1269.869Z",
    transform: "translate(-3267.89 -1249.641)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121641",
    "data-name": "\\uD328\\uC2A4 121641",
    d: "M3315.391,1302.9a32.4,32.4,0,0,1,4.069,3.911q1.958,1.993,3.914,3.989c2.665,2.726,5.4,5.4,8,8.188.357.383-.185.964-.564.593-2.727-2.662-5.337-5.456-8-8.183q-2-2.047-3.991-4.1a31.54,31.54,0,0,1-3.735-4.071C3314.956,1303.047,3315.2,1302.768,3315.391,1302.9Z",
    transform: "translate(-3298.835 -1277.118)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121642",
    "data-name": "\\uD328\\uC2A4 121642",
    d: "M3347,1330.021a9.958,9.958,0,0,1,2.063,1.786c.672.656,1.328,1.33,1.989,2,1.291,1.3,2.565,2.625,3.846,3.939q3.939,4.037,7.865,8.085c.41.422-.22,1.084-.629.662q-3.927-4.049-7.849-8.1c-1.306-1.352-2.621-2.7-3.917-4.06-.647-.682-1.3-1.357-1.938-2.051a9.747,9.747,0,0,1-1.649-2.027A.165.165,0,0,1,3347,1330.021Z",
    transform: "translate(-3335.573 -1299.691)",
    fill: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment8);
export default __webpack_public_path__ + "static/media/recruitment8.d0f7fdce0f1dcdba7bcb769045f63a7d.svg";
export { ForwardRef as ReactComponent };